<template>
    <div>
        <section
            class="itb-top-achievements itb-lazy-loading-bg"
            v-lazy:background-image="'/images/articles/about-us-header.webp'"
        >
            <div class="container">
                <div class="row">
                    <div
                        class="col-12 col-sm-6 col-lg-4"
                        v-for="achievement in achievements['top']"
                    >
                        <div class="itb-card d-flex align-items-center mx-auto">
                            <div class="text-center w-100">
                                <div
                                    class="itb-icon"
                                    :style="
                                        'background-image: url(/images/articles/about-us-' +
                                            achievement.icon +
                                            '.svg)'
                                    "
                                ></div>
                                <h2>{{ achievement.title }}</h2>
                                <p class="mb-0">
                                    {{ achievement.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="/images/logo.png" alt="4Soft logo" class="itb-logo" />
        </section>
        <h2 class="d-none">Časová osa</h2>
        <section class="itb-bottom-achievements">
            <div class="container">
                <div
                    v-for="(achievement, index) in achievements['bottom']"
                    :class="[
                        index == 0 ? 'itb-first-row' : '',
                        index == achievements['bottom'].length - 1
                            ? 'itb-last-row'
                            : '',
                        'row mb-5 mb-sm-0'
                    ]"
                >
                    <div
                        :class="[
                            (index + 1) % 2 != 0
                                ? 'offset-sm-6 itb-right'
                                : 'itb-left',
                            'col-12 col-sm-6 itb-col'
                        ]"
                    >
                        <h3
                            class="itb-year d-sm-none text-center"
                            :class="
                                (index + 1) % 2 != 0
                                    ? 'itb-color-blue'
                                    : 'itb-color-orange'
                            "
                        >
                            {{ achievement.year }}
                        </h3>
                        <div
                            class="itb-card d-flex align-items-center itb-lazy-loading-bg"
                            v-lazy:background-image="
                                achievement.image
                                    ? '/uploads/' +
                                      achievement.image.path +
                                      '/' +
                                      achievement.image.name
                                    : null
                            "
                        >
                            <div class="text-center w-100">
                                <div class="itb-year d-none d-sm-block">
                                    {{ achievement.year }}
                                </div>
                                <div class="itb-content mb-0">
                                    {{ achievement.description }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            achievements: []
        };
    },

    mounted() {
        axios
            .get(`/getAboutUsPage`)
            .then(response => {
                this.pageParams = response.data.params;
                this.achievements = response.data.achievements;

                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    methods: {
        ...mapActions(["setPageParams"])
    }
};
</script>
